.inputs {
  max-width: 200px;
  padding-bottom: 8px;
  &:last-of-type {
    padding-bottom: 24px;
  }
}

.description {
  padding-bottom: 10px;
  font-size: 14px;
}

.banner {
  margin: 10px 0 20px;
  width: 700px;
}
